import React from 'react';

import './DotLoader.scss';

const DotLoader = props => {
  const { content } = props;
  return (
    <div className="dot-loader loading">
      {content}
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  );
};

export default DotLoader;
